import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IProcedureCodes } from 'src/app/models/IProcedureCodes';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { MatDialog, MatTableDataSource, throwToolbarMixedModesError, MatTabChangeEvent } from '@angular/material';
import { MasterCPTComponent } from 'src/app/ChildControls/master-cpt/master-cpt.component';

@Component({
  selector: 'app-cpt-master',
  templateUrl: './cpt-master.component.html',
  styleUrls: ['./cpt-master.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})


export class CptMasterComponent implements OnInit {
  cptMasterForm: FormGroup;
  dataSource1 = new MatTableDataSource<IProcedureCodes>();
  dataSource = new MatTableDataSource<IProcedureCodes>();
  public MasterCPTList: IProcedureCodes[];
  public ActiveCptlist: IProcedureCodes[];

  public masterList: IProcedureCodes[];
  public cptList: IProcedureCodes[];

  public result: any;
  displayedColumns: string[] = ['cptcode', 'description', 'consumerfriendly'];
  displayedColumnss: string[] = ['cptcodes', 'descriptionn', 'consumerfriendly', 'Action'];

  public show: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private formBuilder: FormBuilder, private procedureCodesService: ProcedureCodesService, private toastr: ToastrService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.dataSource1.paginator = this.paginator;
    this.cptMasterForm = this.formBuilder.group({
      MasterCptlist: ['',],
      ActiveCptlist: ['',],
      //cptCode: [''],
    });
    this.getActiveCPTList();
  }

  public newMasterrecord: IProcedureCodes[] = [];

  saveCPTCodes(mastercptObjList: IProcedureCodes[]) {
    if (mastercptObjList.length > 0) {
      this.procedureCodesService.saveActiveCptCodeInfo(mastercptObjList).subscribe(
        results => {
          this.result = results;
          if (this.result != "") {
            this.toastr.success(this.result);
            this.newMasterrecord = [];
          }
          this.getActiveCPTList();
        });
    }
  }

  getActiveCPTList() {
    this.procedureCodesService.getActiveCptCodes(1, 10, '').subscribe(
      results => {
        this.ActiveCptlist = results;
        this.dataSource1.data = this.ActiveCptlist;
        this.cptMasterForm.patchValue({
          cptCode: false,
        });
        // this.dataSource.paginator = this.paginator;
      });
  }

  deleteCPTCode(element) {

    const message = "Are you sure to delete this CPT Code ? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '130px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        this.procedureCodesService.deleteActiveCodes(element.cptMasterId).subscribe(
          results => {
            this.toastr.success(results);
            this.getActiveCPTList();
          }, (err: any) => console.log(err));
      } else {
        this.result = dialogResult;
      }

    });
    // this.procedureCodesService.deleteActiveCodes(element.cptMasterId).subscribe(
    //   results => {
    //     this.toastr.success(results);
    //     this.getActiveCPTList();
    //   }, (err: any) => console.log(err));


  }

  updateCPTCodeStatus(element) {

    const message = "Are you sure to delete this CPT Code ? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '130px',
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      this.result = dialogResult;
      if (this.result) {
        this.procedureCodesService.updateIsActiveStatusCPTCodes(element.cptMasterId).subscribe(
          results => {
            this.toastr.success(results);
            this.getActiveCPTList();
          }, (err: any) => console.log(err));
      } else {
        this.result = dialogResult;
      }

    });
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    //Filtering specific column data
    this.dataSource1.filterPredicate = function (data, filter: string): boolean {
      return data.cptCode.toLowerCase().includes(filter) || data.procedureName.toLowerCase().includes(filter) || data.aliasName.toLowerCase().includes(filter);
    };

    this.dataSource1.filter = filterValue;
  }

  OpenMasterCPTPopUp(): void {
    const dialogRef = this.dialog.open(MasterCPTComponent,
      {
        width: '1000px',
        height: '500px'
      });
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        this.newMasterrecord = result;
        this.saveCPTCodes(this.newMasterrecord);
      } else {
      }

    });
  }
}
